module.exports = __webpack_public_path__ + "static/media/brightLogo.b5acea40.png";